import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详细")

import { h, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElButton, ElTag } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useAppStore } from '@/store/app';
import { useDictionary } from '@/store/dictionary.store';
import { GetContractListApi, delContract } from '@/apis/contract/contract.api';
import { ContractList } from '@/apis/contract/contract.type';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { ContractSearch } from '../../apis/contract/contract.type';
import moment from 'moment';

/* GbTable 配置 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { register, tableObject, methods } = useGbTable<ContractList>({
	getListApi: GetContractListApi,
	delListApi: delContract,
	response: { data: 'data', total: 'total' },
});

const { getName } = useDictionary();
const { setSearchParams } = methods;
const { push } = useRouter();
const { query } = useRoute();
const appStore = useAppStore();

/* 控制变量 */
const margetModel = ref<string>((query.mode as string) || 'list');

const searchDto = reactive<ContractSearch>({
	page_size: 10,
	current: 1,
	status: 5,
	page_type: margetModel.value == 'list' ? undefined : '1',
});

/* 字典启用状态格式化 */
const statusFormatter = (_: Recordable, __: TableColumn, cellValue: string) => {
	const dicName = getName('contract_status', cellValue);

	if (cellValue == '1') {
		return h(ElTag, { size: 'small', type: 'warning' }, () => dicName);
	} else if (cellValue == '2') {
		return h(ElTag, { size: 'small', type: '' }, () => dicName);
	} else if (cellValue == '8') {
		return h(ElTag, { size: 'small', type: 'info' }, () => dicName);
	} else {
		return h(ElTag, { size: 'small', type: 'success' }, () => dicName);
	}
};

setSearchParams(searchDto);

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'status', label: '状态', align: 'center', columnWidth: '80', formatter: statusFormatter },
	{ field: 'no', label: '合同编号', columnWidth: '150' },
	{ field: 'name', label: '合同名称', columnWidth: '200' },
	{ field: 'counterpart_name', label: '相对方' },
	{ field: 'plan_a_name', label: '我方主体' },
	{ field: 'sign_day', label: '签订日期', columnWidth: '120' },
	{ field: 'contract_amount', label: '合同总价', columnWidth: '120', align: 'right' },
	{ field: 'next_node_name', label: '下一节点', columnWidth: '100', align: 'center' },
	{ field: 'next_emp_name', label: '处理人', columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: '创建日期', columnWidth: '120', fixed: 'right' },
	{ field: 'action', width: '100px', label: '操作', fixed: 'right', align: 'center' },
]);

/* 数据查询 */
const onSearchBtnClick = () => {
	setSearchParams(searchDto);
};

const rowPreViewAcion = (rowID: string) => {
	push(`/contract/detail?contractId=${rowID}`);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(searchDto),
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "合同编号",
              prop: "no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(searchDto).no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchDto).no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "合同名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(searchDto).name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchDto).name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  onClick: onSearchBtnClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"},
      disabled: _unref(tableObject).loading
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          contract_amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.contract_amount.toLocaleString('zh')), 1)
          ]),
          sign_day: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.sign_day).format('YYYY-MM-DD')), 1)
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          action: _withCtx(({ row }) => [
            (margetModel.value == 'list')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(ElButton), {
                    type: "info",
                    link: "",
                    onClick: ($event: any) => (rowPreViewAcion(row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})